import { Env } from "@stencil/core";
import i18next from "i18next";
import LanguageDetector from 'i18next-browser-languagedetector';

const i18nextInstance = i18next.createInstance();

const translationsLoadedEvent = new CustomEvent('translationsLoaded');

i18nextInstance.use(LanguageDetector).init({
	detection: {
		order: ['querystring', 'htmlTag', 'path', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'subdomain'],
	},
	debug: false,
	fallbackLng: {
		'de-DE': ['de', 'en'],
		'de-CH': ['de', 'fr', 'it'],
		'de-AT': ['de'],
		'tr-TR': ['tr', 'en'],
		'default': ['en']
	},
	defaultNS: "fslabels",
	resources: {}
}).then(() => {
	// dynamic loading fs labels
	fetch(Env.TRANSLATION_JSON_URL, { cache: "no-cache" })
		.then(response => {
			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}
			return response.json();
		}).then(parsedResponse => {
			Object.entries(parsedResponse).forEach(([locale, translation]) => {
				i18nextInstance.addResourceBundle(locale, "fslabels", translation["fslabels"]);
			});
			// Dispatch event to notify components
			window.dispatchEvent(translationsLoadedEvent);
		}).catch(error => {
			console.error("Error fetching FS-Labels:", error);
		});
}).catch(error => console.error(error));

export default i18nextInstance;